<ng-container *transloco="let t; read: 'ime.common.property-mappings'">
  <div class="modal-header" ngxModalDraggable>
    <h6 *ngIf="expression.Comments">{{expression.Comments | shorten: 200: '...'}}</h6>
    <div class="ms-auto">
      <button type="button" class="btn btn-sm btn-outline-primary" (click)="beautify()">
        {{t('Beautify')}}
      </button>
      <button type="button" class="btn btn-sm btn-outline-primary ms-1" (click)="showFindAndReplace = !showFindAndReplace">
        {{t('Find & replace')}}
      </button>
      <button type="button" class="btn btn-sm btn-primary ms-1" (click)="close(expression)">
        {{t('OK')}}
      </button>
      <help-button *transloco="let h" [key]="h('help.ime.common.expression-formula')"></help-button>
      <button type="button" class="btn-close pull-right" aria-label="Close" (click)="close(expression)">
      </button>
    </div>
  </div>
  <div class="modal-body">
    <form>
      <ul ngbNav #nav="ngbNav" class="nav-tabs" (navChange)="currentTab = $event.nextId">
        <li class="mt-auto" ngbNavItem="formula" [destroyOnHide]="false">
          <a ngbNavLink>{{t('Formula')}}</a>
          <ng-template ngbNavContent>
            <ace #formulaEditor class="ace-fixed-height" autofocus [config]="config" [(value)]="expression.Formula" [disabled]="readonly">
            </ace>
          </ng-template>
        </li>
        <li class="mt-auto" ngbNavItem="externalFormula" [destroyOnHide]="false" *ngIf="hasExternalFormula">
          <a ngbNavLink>{{t('External formula')}}</a>
          <ng-template ngbNavContent>
            <ace #externalFormulaEditor class="ace-fixed-height" [config]="config" [(value)]="expression.ExternalFormula" [disabled]="readonly">
            </ace>
          </ng-template>
        </li>
        <li class="mt-auto" ngbNavItem="comments" [destroyOnHide]="false" *ngIf="expression.Comments">
          <a ngbNavLink>{{t('Results')}}</a>
          <ng-template ngbNavContent>
            <ace #commentsEditor class="ace-fixed-height" [config]="config" [(value)]="expression.Comments" [disabled]="true">
            </ace>
          </ng-template>
        </li>
        <li class="ms-auto text-gray-600" *ngIf="showFindAndReplace">
          <div class="mb-1">
            <div class="input-group">
              <input #findInput type="text" class="form-control" mesAutoFocus [placeholder]="t('Find')" (input)="find(findInput.value)">
              <button class="btn btn-outline-default" type="button" (click)="findPrevious()"><svg viewBox="0 0 8 8" class="icon small" inlineSVG="#chevron-left"></svg></button>
              <button class="btn btn-outline-default" type="button" (click)="findNext()"><svg viewBox="0 0 8 8" class="icon small" inlineSVG="#chevron-right"></svg></button>
            </div>
            <div class="input-group mt-1">
              <input #replaceInput type="text" class="form-control" [placeholder]="t('Replace')">
              <button class="btn btn-outline-default" type="button" (click)="replace(replaceInput.value, findInput.value)">{{t('Replace')}}</button>
              <button class="btn btn-outline-default" type="button" (click)="replaceAll(replaceInput.value)">{{t('Replace all')}}</button>
            </div>
          </div>
        </li>
      </ul>
      <div [ngbNavOutlet]="nav"></div>
    </form>
  </div>
</ng-container>


